import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@sparro/env/environment';

@Component({
  selector: 'uni-user-name',
  templateUrl: './user-name.component.html',
  styleUrls: ['./user-name.component.scss']
})
export class UserNameComponent implements OnInit {
  @Input() user: any;
  @Input() truncateAt: number = 1000;
  displayName: string;

  constructor() { }

  ngOnInit(): void {
    this.displayName = `${this.user.first_name} ${this.user.last_name}`;
  }

  getProfileUrl(): string {
    return `${environment.profileUrl}${this.user.username}/`;
  }
}
